import { createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "mt-2 mb-2 text-black"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "text-center font-italic"
}
const _hoisted_10 = {
  key: 3,
  class: "crm:flex crm:justify-end"
}
const _hoisted_11 = { class: "form-group mb-3" }
const _hoisted_12 = { class: "form-group mb-3" }
const _hoisted_13 = {
  class: "btn-group ms-2",
  role: "group"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { key: 1 }

import {inject, ref, watch} from 'vue';
import {formatDateEnToIT} from '../../filters/common.filters.js'
import {useRoute, useRouter} from "vue-router";
import Front from './Front.vue'
import AppChecklistMatrice from "../../modules/checklist-matrice/AppChecklistMatrice.vue";
import BaseUploadFilesList from "../BaseUploadFilesList.vue";
import BaseInputFile from '../BaseInputFile.vue'
import BaseLoader from "fallco-frontend-framework/src/vue/plugins/BaseLoader/BaseLoader.vue";
import Utilities from "fallco-frontend-framework/src/js/libs/utilities/index.js";
import {createPluginInstance} from '../../core/plugins/create-dynamic-instance.js'
import {useChecklistStore, usePraticaStore} from "../../store/crm.store";
import {useQuestionario} from "../../composable/useQuestionario";
import {useRefreshChecklist} from "../../composable/useRefreshChecklist.feacture";
import {useDefineModal} from "../../composable/definer/useDefineModal";


export default {
  __name: 'Checklist',
  props: {
  /**
   *  Se settato a true mostrerà solo gli elementi che hanno lo stato accettato a 1
   *  Il default mostra tutti gli elementi di un questionario/checklist
   */
  mostraSoloAccettati: {
    type: Boolean,
    default: false
  },
  /**
   *  Tipologia di View del Questionario da renderizzare
   */
  state: {
    type: String,
    default: 'admin'
  },
  /**
   * Elenco dei Questionari Possibili
   */
  questionari: {
    type: [Object, Array],
    default() {
      return {};
    }
  }
},
  emits: [
  'chiudiQuestionario',
  'chiudiBozzaQuestionario',
  'onChiudiModaleValidazioneChecklist',
  'onConcludiValidazione'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc Gestisce e renderizza tutti gli elementi di una checklist già composta
 */
const props = __props
const emits = __emit

const route = useRoute()
const router = useRouter()

/**
 * @inject {$AxiosClient} recupera la libreria per le chiamate ajax
 */
const $AxiosClient = inject('$AxiosClient');

/**
 * @inject {$L_} shortcut per accedere ai metodi di lodash messi a disposizione nel base_instance
 */
const $L_ = inject('$L_');

const praticaStore = usePraticaStore();
const checklistStore = useChecklistStore();

const {
  elementiDelQuestionarioFlat,
  abilitaDopoSyncRisposteDelQuestionario,
  statoDelQuestionario,
  isFront,
  isReadonly,
  titoloDellaChecklist,
  noteQuestionario,
  salvaBozzaQuestionario,
  salvaBozzaQuestionarioLatoNotaio,
  concludiValidazione,
  inviaQuestionarioAlNotaio,
  init,
  apriDettaglioChecklist
} = useQuestionario(props, router, route, checklistStore, praticaStore, emits);

const initialize = async() => {
  await init();
}

initialize()

watch(props, (newValue) => {
  if (checklistStore.risposteDelQuestionario) {
    checklistStore.risposteDelQuestionario.value = newValue.questionari[0].atom_components.elements
  }
})

const hashNuovaDomanda = ref(null)

const documentoPersonalizzatoChecklist = ref({
  "tipo": {"value": ""},
  "file_upload": {"value": [], "required": true, "isvalid": true},
  "descrizione": {"value": "", "required": true, "isvalid": true}
})

const modaleNuovoDocumentoChecklist = useDefineModal('carica_documento_in_checklist', 'Aggiungi documento alla checklist', false)

/**
 *
 * @return {Promise<*[]>}
 */
async function inserisciDocumentoPersonalizzato() {
  const carica_documento_instance = createPluginInstance(BaseLoader)
  carica_documento_instance.mount.show();

  let formData = documentoPersonalizzatoChecklist.value;
  let filesData = formData.file_upload.value;
  let idDomanda = parseInt(Math.round(Math.random() * 1000));
  let infoAggiuntive = {
    component: 'base-input-file',
    id: idDomanda,
    tipo_domanda_id: idDomanda,
    name: formData.descrizione.value,
    title: formData.descrizione.value,
    label: formData.descrizione.value,
    pratica_id: praticaStore.praticaID,
    questionario_id: props.questionari[0].questionario_id,
    required: true,
    hash: hashNuovaDomanda.value,
    hash_domanda: hashNuovaDomanda.value
  };

  let saveFilesResponse = [];
  let fileDaAggiornareArray = [];
  let inviaNotifiche = true;

  for (const dataKey of Object.keys(filesData)) {
    var formDataToSend = new FormData();
    const randomID = Utilities.generate_random_id();
    formDataToSend.append(`${randomID}[]`, filesData[dataKey]);
    formDataToSend.append("questionario_id", props.questionari[0].questionario_id);
    formDataToSend.append("hash_domanda", hashNuovaDomanda.value);
    formDataToSend.append("pratica_id", praticaStore.praticaID);
    Object.keys(infoAggiuntive).forEach(prop => {
      formDataToSend.append(`file_upload[${randomID}][${prop}]`, infoAggiuntive[prop])
    })

    saveFilesResponse = await $AxiosClient.post('Questionario', 'saveQuestionarioFiles', formDataToSend, {headers: {"Content-Type": "multipart/form-data"}},)

    carica_documento_instance.mount.hide();
    carica_documento_instance.app.unmount();

    if (saveFilesResponse && saveFilesResponse.esito === 'ko') {
      inviaNotifiche = false;
      let fileDaAggiornare = documentoPersonalizzatoChecklist.value.file_upload.value[dataKey];
      let responseHash = Object.keys(saveFilesResponse.files)[0];
      fileDaAggiornare.file_id = saveFilesResponse.files[responseHash][0].file_id;
      fileDaAggiornare.validate = saveFilesResponse.esito === 'ok';
      fileDaAggiornare.error = saveFilesResponse.files[responseHash][0].error;
      fileDaAggiornare.message = (saveFilesResponse.files[responseHash][0].error) ? saveFilesResponse.files[responseHash][0].error : 'File caricato con successo';
      fileDaAggiornareArray.push(fileDaAggiornare);
    }
  }

    if(inviaNotifiche) {
      modaleNuovoDocumentoChecklist.close();
      await checklistStore.onResponseQuestionariRichiesti({init: false, objectToRequest: {
          questionario_id: props.questionari[0].questionario_id,
          pratica_id:  praticaStore.praticaID
        }});
      checklistStore.is_show_checklist = false

      setTimeout(() => {
        checklistStore.is_show_checklist = true
      }, 100)
    }

  documentoPersonalizzatoChecklist.value.file_upload.value = $L_.cloneDeep(fileDaAggiornareArray);

  return fileDaAggiornareArray;
}

/**
 *
 */
function apriModaleAggiungiDocumentoPersonalizzato() {
  hashNuovaDomanda.value =  Math.random().toString(36).substring(2, 5) + Math.random().toString(36).substring(2, 5);
  modaleNuovoDocumentoChecklist.open()
}

const modaleAggiungiRichiestaDocumenti = useDefineModal('aggiungi_documenti_da_richiedere', 'Aggiungi documenti da richiedere', false)

const {refreshChecklist} = useRefreshChecklist()

/**
 * Esegue il refresh della checklist e chiude la modale di "aggiungi richieste di documenti"
 * @param soggettoID
 * @param isOpenModal
 * @param responseQuestionariRichiestiParams
 * @return {Promise<void>}
 */
async function refreshChecklistBridge(soggettoID, isOpenModal, responseQuestionariRichiestiParams) {
  await refreshChecklist(soggettoID, responseQuestionariRichiestiParams);
  modaleAggiungiRichiestaDocumenti.close();
}

return (_ctx, _cache) => {
  const _component_base_form = _resolveComponent("base-form")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_input_text_floating_label = _resolveComponent("base-input-text-floating-label")
  const _component_base_modal = _resolveComponent("base-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("\r\n   Lato Cliente: form del questionario\r\n   Al form viene passato l'oggetto FLAT del json iniziale per verificare required ed eventuali tipizzazioni\r\n  "),
    (_unref(isFront))
      ? (_openBlock(), _createBlock(_component_base_form, {
          key: 0,
          name: "questionarioJSON",
          "post-params": {url: 'Pratica', action: 'process'},
          data: _unref(elementiDelQuestionarioFlat),
          actionsSetting: {'continue': {show: false}, 'reset': {show:false}, 'confirm':{show:false}}
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" intestazione "),
            (_unref(checklistStore).questionarioAttivo)
              ? (_openBlock(), _createElementBlock("h5", {
                  key: 0,
                  class: _normalizeClass(["mt-2 text-black", {'mb-4': !_unref(checklistStore).questionarioAttivo.last_modified_at, 'mb-2':_unref(checklistStore).questionarioAttivo.last_modified_at}]),
                  innerHTML: _unref(titoloDellaChecklist)
                }, null, 10 /* CLASS, PROPS */, _hoisted_1))
              : _createCommentVNode("v-if", true),
            (_unref(checklistStore).questionarioAttivo.last_modified_at)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "c-grey mt-0 mb-4",
                  innerHTML: `Ultimo aggiornamento: ${_unref(formatDateEnToIT)(_unref(checklistStore).questionarioAttivo.last_modified_at)}`
                }, null, 8 /* PROPS */, _hoisted_2))
              : _createCommentVNode("v-if", true),
            (_unref(checklistStore).questionarioAttivo.atom_components && _unref(checklistStore).questionarioAttivo.atom_components.note)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  role: "alert",
                  class: "c-balloon my-2",
                  innerHTML: _unref(noteQuestionario)
                }, null, 8 /* PROPS */, _hoisted_3))
              : _createCommentVNode("v-if", true),
            _cache[9] || (_cache[9] = _createElementVNode("div", { id: "front-loader-readonly" }, null, -1 /* CACHED */)),
            _createCommentVNode(" render elementi del form "),
            (_unref(checklistStore).risposteDelQuestionario)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_unref(checklistStore).risposteDelQuestionario, (atom_component, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (_unref(abilitaDopoSyncRisposteDelQuestionario))
                      ? (_openBlock(), _createBlock(Front, {
                          statoDelQuestionario: _unref(statoDelQuestionario),
                          key: index,
                          atom_component: atom_component,
                          index: index,
                          "questionario-id": _unref(checklistStore).questionarioAttivo.questionario_id
                        }, null, 8 /* PROPS */, ["statoDelQuestionario", "atom_component", "index", "questionario-id"]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          actionsLeft: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-default",
              type: "button",
              onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => (_unref(salvaBozzaQuestionario) && _unref(salvaBozzaQuestionario)(...args)), ["prevent"]))
            }, " Salva in Bozza ")
          ]),
          actionsRight: _withCtx(({formInValid, formNotComplete}) => [
            (_unref(praticaStore).tipoUtenteConnesso === 'cittadino')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-default me-2",
                  onClick: _withModifiers(apriModaleAggiungiDocumentoPersonalizzato, ["prevent"])
                }, " Aggiungi documento personalizzato "))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_unref(inviaQuestionarioAlNotaio) && _unref(inviaQuestionarioAlNotaio)(...args)), ["prevent"])),
              type: "button",
              class: "btn btn-primary",
              disabled: _unref(checklistStore).controlloDisabilitaPerBottoneValidazione
            }, "Invia Documenti ", 8 /* PROPS */, _hoisted_4)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["data"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" checklist di sola consultazione "),
    (_unref(isReadonly))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(checklistStore).questionarioAttivo)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, [
                _createTextVNode(" Checklist " + _toDisplayString(_unref(praticaStore).tipoUtenteConnesso !== 'notaio' ? 'ricevuta' : 'inviata') + " il ", 1 /* TEXT */),
                _createElementVNode("span", {
                  innerHTML: _unref(formatDateEnToIT)(_unref(checklistStore).questionarioAttivo.created_at)
                }, null, 8 /* PROPS */, _hoisted_6)
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(checklistStore).questionarioAttivo.last_modified_at)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "c-grey mt-0",
                innerHTML: `Ultimo aggiornamento: ${_unref(formatDateEnToIT)(_unref(checklistStore).questionarioAttivo.last_modified_at)}`
              }, null, 8 /* PROPS */, _hoisted_7))
            : _createCommentVNode("v-if", true),
          (_unref(checklistStore).questionarioAttivo.atom_components && _unref(checklistStore).questionarioAttivo.atom_components.note)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                role: "alert",
                class: "c-balloon my-2",
                innerHTML: _unref(noteQuestionario)
              }, null, 8 /* PROPS */, _hoisted_8))
            : _createCommentVNode("v-if", true),
          _cache[10] || (_cache[10] = _createElementVNode("div", { id: "front-loader-readonly" }, null, -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checklistStore).risposteDelQuestionario, (atom_component, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (_unref(abilitaDopoSyncRisposteDelQuestionario) && (!atom_component.non_richiesto || (atom_component.non_richiesto && atom_component.value && atom_component.value.length > 0)))
                ? (_openBlock(), _createBlock(Front, {
                    statoDelQuestionario: "readonly",
                    key: index,
                    atom_component: atom_component,
                    index: index,
                    "questionario-id": _unref(checklistStore).questionarioAttivo.questionario_id
                  }, null, 8 /* PROPS */, ["atom_component", "index", "questionario-id"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (!_unref(checklistStore).questionarioAttivo && _unref(praticaStore).tipoUtenteConnesso !== 'notaio')
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Al momento non vi è nessuna attività in sospeso da completare"))
      : _createCommentVNode("v-if", true),
    (_unref(praticaStore).tipoUtenteConnesso === 'notaio')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_unref(checklistStore).questionarioAttivo.readonly === false)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                class: "crm:mr-2!",
                "onClick:cta": _cache[2] || (_cache[2] = $event => (_unref(modaleAggiungiRichiestaDocumenti).open()))
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" Aggiungi richieste di documenti ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          (_unref(checklistStore).questionarioAttivo)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 1,
                class: "crm:mr-2!",
                "onClick:cta": _unref(salvaBozzaQuestionarioLatoNotaio)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString((!_unref(checklistStore).questionarioAttivo.is_to_do) ? 'Esci' : 'Esci e salva'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick:cta"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_base_button, {
            mode: "confirm",
            "onClick:cta": _cache[3] || (_cache[3] = $event => (_unref(concludiValidazione)('questionario_readonly'))),
            state: _unref(checklistStore).controlloDisabilitaPerBottoneValidazione ? 'disable' : 'active'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(checklistStore).questionarioAttivo.is_to_do ? 'Concludi operazione di validazione' : 'Concludi'), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["state"])
        ]))
      : _createCommentVNode("v-if", true),
    (_unref(modaleNuovoDocumentoChecklist).getShow())
      ? (_openBlock(), _createBlock(_component_base_modal, {
          key: 4,
          title: _unref(modaleNuovoDocumentoChecklist).getTitle(),
          id: _unref(modaleNuovoDocumentoChecklist).getId(),
          size: "md",
          "onModal:closed": _cache[7] || (_cache[7] = $event => (_unref(modaleNuovoDocumentoChecklist).close()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_form, {
              name: "form_carica_documento_in_checklist",
              data: documentoPersonalizzatoChecklist.value,
              "post-params": {url: 'Pratica', action: 'saveFiles' },
              onResetFormCallback: _cache[6] || (_cache[6] = $event => (_unref(modaleNuovoDocumentoChecklist).close())),
              actionsSetting: {'confirm': {show: false},'continue': {show: false}}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-gray-50" }, "Documento", -1 /* CACHED */)),
                  _createVNode(BaseInputFile, {
                    name: "documento",
                    "extension-accepted": _unref(praticaStore).documentExtensionAccepted,
                    "http-options": {remove: {module: 'Pratica', action:'setDeleteFile'}},
                    "validate-to": documentoPersonalizzatoChecklist.value.file_upload,
                    value: documentoPersonalizzatoChecklist.value.file_upload.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = $event => ((documentoPersonalizzatoChecklist.value.file_upload.value) = $event))
                  }, {
                    default: _withCtx(({filesUploaded, filesRejected, cancellaFile, downloadFile, progressSize}) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filesRejected, (file, index) => {
                        return (_openBlock(), _createBlock(BaseUploadFilesList, {
                          key: `rejected-${index}`,
                          arrayIndex: index,
                          file: file,
                          onRemoveFileClick: cancellaFile,
                          onDownloadFileClick: downloadFile
                        }, null, 8 /* PROPS */, ["arrayIndex", "file", "onRemoveFileClick", "onDownloadFileClick"]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filesUploaded, (file, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          file
                            ? (_openBlock(), _createBlock(BaseUploadFilesList, {
                                key: 0,
                                file: file,
                                arrayIndex: index,
                                onRemoveFileClick: cancellaFile,
                                onDownloadFileClick: downloadFile
                              }, null, 8 /* PROPS */, ["file", "arrayIndex", "onRemoveFileClick", "onDownloadFileClick"]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["extension-accepted", "validate-to", "value"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_base_input_text_floating_label, {
                    name: "descrizione",
                    label: "Titolo",
                    "validate-to": documentoPersonalizzatoChecklist.value.descrizione,
                    "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((documentoPersonalizzatoChecklist.value.descrizione) = $event))
                  }, null, 8 /* PROPS */, ["validate-to"])
                ])
              ]),
              actionsRight: _withCtx(({formIsValid, formIsComplete}) => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "submit",
                    ref: "submitBtn",
                    onClick: _withModifiers(inserisciDocumentoPersonalizzato, ["prevent"]),
                    disabled: !formIsComplete
                  }, " Inserisci ", 8 /* PROPS */, _hoisted_14)
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["data"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title", "id"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" possibilità di modificare la checklist "),
    (_unref(modaleAggiungiRichiestaDocumenti).getShow())
      ? (_openBlock(), _createBlock(_component_base_modal, {
          key: 5,
          title: _unref(modaleAggiungiRichiestaDocumenti).getTitle(),
          id: _unref(modaleAggiungiRichiestaDocumenti).getId(),
          "onModal:closed": _cache[8] || (_cache[8] = $event => (_unref(modaleAggiungiRichiestaDocumenti).close()))
        }, {
          default: _withCtx(() => [
            _createVNode(AppChecklistMatrice, {
              "checklist-id": _unref(checklistStore).questionari[0].questionario_id,
              "soggetto-id": _unref(checklistStore).questionari[0].soggetto_id,
              "onSave:checklist": refreshChecklistBridge
            }, {
              "matrice-title": _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(_toDisplayString(null), -1 /* CACHED */)
              ]))]),
              "matrice-nota-generale": _withCtx(() => [
                (_unref(checklistStore).questionarioAttivo.atom_components && _unref(checklistStore).questionarioAttivo.atom_components.note)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      role: "alert",
                      class: "c-balloon my-2",
                      innerHTML: _unref(noteQuestionario)
                    }, null, 8 /* PROPS */, _hoisted_15))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(null)))
              ]),
              "matrice-invio-mail": _withCtx(() => [
                (_unref(checklistStore).questionarioAttivo.atom_components && _unref(checklistStore).questionarioAttivo.atom_components.note)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      role: "alert",
                      class: "c-balloon my-2",
                      innerHTML: _unref(noteQuestionario)
                    }, null, 8 /* PROPS */, _hoisted_17))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(null)))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["checklist-id", "soggetto-id"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title", "id"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}